import { Modal, Button, Table, InputGroup, Form, Dropdown } from 'react-bootstrap';
import { useState } from 'react';
import { useFormik } from 'formik';
import Select from 'react-select';
import { Popover } from 'react-tiny-popover';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import currency from 'currency.js';
import DateTime from 'react-datetime';
import moment from 'moment';

import { CustomInput } from '../utils/CustomInput';
import { useAuth } from '../../hooks/useAuth';
import '../../assets/scss/scoped/issueItem.scss';
import ConfirmDialog from '../ConfirmDialogue';
import { fetchActionsUtil } from '../../utils/helpers';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import { DeleteIcon, TagSimpleIcon } from '../Icons';
import ModalLoader from '../utils/ModalLoader';
import { backendApis } from '../../config';
import CachedIcon from 'mdi-react/CachedIcon';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import GetTemplateModal from './GetProductionTemplateModal';
import ShowProjectedItemsDialog from './ShowProjectedItems';

const initialValues = {
  RequesterName: '',
  Requester: '',
  UserName: '',
  plant: '',
  Warehouse: '',
  WarehouseName: '',
  issueTo: '',
};

const issuedToData = backendApis.map((el) => ({
  value: el.name,
  label: el.name,
}));

export const CreateProductLogModal = (props) => {
  const [showItemsPopover, setShowItemsPopover] = useState(false);
  const [showPopoverItems, setShowPopoverItems] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [activeTableIndex, setActiveTableIndex] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [activeSelected, setActiveSelected] = useState('Plan');

  //=====================
  const [allstaff, setAllStaff] = useState([]);
  const [allWarehouse, setAllWarehouse] = useState([]);
  // ====================

  const { backendUrl, token, user } = useAuth();

  const handleInputChange = ({ index, name, value }) => {
    const oldTableData = [...tableData];
    oldTableData[index][name] = value;

    // Calculate total amount if quantity or unit cost changes
    if (name === 'Quantity' || name === 'UnitCost') {
      const quantity =
        name === 'Quantity'
          ? parseFloat(value) || 0
          : parseFloat(oldTableData[index].Quantity) || 0;
      const unitCost =
        name === 'UnitCost'
          ? parseFloat(value) || 0
          : parseFloat(oldTableData[index].UnitCost) || 0;
      oldTableData[index].totalAmount = quantity * unitCost;
    }

    setTableData(oldTableData);
  };

  const [isLoadingAddToCart, setIsLoadingAddToCart] = useState(false);

  const plantLocal = JSON.parse(window.localStorage.getItem('plantDetails'));

  const fetchItems = async () => {
    const data = await fetchActionsUtil(
      `${backendUrl}/api/production/IssueTo_Officers`,
      'GET',
      token
    );
    data.staffs = data.staffs.map((el) => ({
      value: el.Staff_ID,
      label: el.Name,
    }));

    data.warehouse = [{ value: 'Sales', label: 'Sales' }].concat(
      ...data.warehouse.map((el) => ({
        value: el.W_ID,
        label: el.W_name,
      }))
    );

    return data;
  };

  const { isLoading } = useQuery(['GET_OTHERS'], () => fetchItems(), {
    enabled: true,
  });

  const sendProductLog = useMutation(
    (payload) =>
      fetchActionsUtil(
        `${backendUrl}/api/production/product-log/${plantLocal.PLID}`,
        'POST',
        token,
        payload
      ),
    {
      onSuccess: ({ message, data }) => {
        toast.success('Sent to C of A');

        formik.resetForm({
          values: {
            ...initialValues,
          },
        });

        setTableData([]);
        props.refetchMain();
      },
      onError: () => {
        toast.error(`Unable to perform action`);
      },
    }
  );

  const formik = useFormik({
    initialValues,

    onSubmit: async (values) => {
      if (tableData.length < 1) {
        return toast.error('Add Items');
      }

      // Validate that all required fields are filled for each item
      const invalidItems = tableData.filter(
        (item) =>
          !item.Quantity || !item.UnitCost || !item.Date_Log || !item.issueTo || !item.RequesterName
      );

      if (invalidItems.length > 0) {
        return toast.error('Please fill all required fields for each item');
      }

      const errors = [];

      let tableDataModified = tableData.map((el) => {
        if (!el?.Warehouse) {
          errors.push(
            `${el?.Item_Name} : The warehouse field is missing for this item`
          );
        } else if (!el?.issueTo) {
          errors.push(
            `${el?.Item_Name} : The issue to field is missing for this item`
          );
        } else if (!el?.receivingofficer) {
          errors.push(
            `${el?.Item_Name
            } : The receiving officer field is missing for this item`
          );
        } else if (!el?.Quantity || parseFloat(el?.Quantity) <= 0) {
          errors.push(
            `${el?.Item_Name} : The quantity field is missing for this item`
          );
        }

        let sendToUrl = "";
        const sendTo = backendApis.find((item) => item?.name === el.issueTo);
        if (sendTo) {
          console.log('sendTo', sendTo);
          if (el.Requester === '' || el.Requester === 'Sales') {
            sendToUrl = `${sendTo?.url}/api/itemissuer/receiver`;
            el.Warehouse = '';
            el.WarehouseName = '';
          } else {
            sendToUrl = `${sendTo?.url}/api/warehouse/receiver`;
          }
        } else {
          toast.warning(`No backend found for ${el.issueTo}`);
          return el;
        }
        return {
          ...el,
          sendForApproval: true,
          sendTo: sendToUrl,
          url: sendTo,
        };
      });

      console.log({ tableDataModified });

      // Confirm dialog if there are validation errors
      if (errors.length > 0) {
        const displayErrors = `${errors
          ?.map((error) => `${error}`)
          .join("\n")}\n`;

        return toast.error(displayErrors, {
          position: "top-center",
        });
      }

      if (
        await ConfirmDialog({
          title: 'Save Production',
          description: 'Are you sure you want to save this production',
        })
      ) {
        sendProductLog.mutate(tableDataModified);
      }
    },
  });

  const addToTable = async (el, index) => {
    if (el.Bar_Code === '') {
      return toast.error('Enter Item Id');
    }
    if (el.Quantity === '') {
      return toast.error('Quantity');
    }
    // if (el.Requester === '') {
    //   return toast.error('Choose Issue To');
    // }
    // if (el.RequesterName === '') {
    //   return toast.error('Choose Receiving Officer');
    // }

    // let newData = { ...el };

    // const existingIndex = tableData.findIndex((item) => item.Bar_Code === newData.Bar_Code);

    // let updatedTableData = [...tableData];

    const newData = await ShowProjectedItemsDialog({ mainData: el });

    if (!newData) {
      return;
    }

    // newData = returnData;

    const newPro = newData?.prod_profiles?.map((el) => ({
      ...el,
      quantity: parseFloat(el?.actual) + parseFloat(el?.damage),
    }));

    const newitems = { ...newData, prod_profiles: newPro };

    try {
      setIsLoadingAddToCart(true);
      const { message } = await fetchActionsUtil(
        `${backendUrl}/api/production/check-quantity-items/${plantLocal.PLID}`,
        'POST',
        token,
        newitems
      );

      if (message.length > 0) {
        const errors = message.map((item, i) => (
          <div className='my-2'>
            {i + 1}. {item?.message}
          </div>
        ));
        return setErrorMessage(errors || 'Item Required not enough');
      } else {
        setErrorMessage(null);
      }
    } catch (error) {
      console.log(error);
      return;
    } finally {
      setIsLoadingAddToCart(false);
    }

    // if (existingIndex !== -1) {
    //   updatedTableData[existingIndex] = newData;
    // } else {
    //   updatedTableData.push(newData);
    // }
    let newTableData = tableData;
    newTableData[index] = newitems;
    setTableData((prev) => [...prev, ...newTableData]);
    // resetSelectedItem();
  };

  const handleSelectedItem = async (items) => {
    console.log('selected items', items);
    setTableData([]);

    setShowItemsPopover(false);
    setShowPopoverItems(false);

    // Handle array of items from product plan
    if (Array.isArray(items)) {
      const newItems = [];

      for (const item of items) {
        if (!item?.accountName || !item?.DetailType) {
          toast.error(`Add account to template for item: ${item.Item_Name}`);
          continue;
        }

        // Check if item already exists in table
        const existingIndex = tableData.findIndex(
          (tableItem) => tableItem.Bar_Code === item.Bar_Code
        );

        const newItem = {
          ...item,
          Quantity: item.Quantity || 1,
          UnitCost: item.UnitCost || 0,
          Date_Log: moment(new Date()),
          UserName: user.username,
          plant: plantLocal?.PLID,
          issueTo: formik.values.issueTo || '',
          Requester: formik.values.Requester || '',
          RequesterName: formik.values.RequesterName || '',
          Warehouse: formik.values.Warehouse || '',
          WarehouseName: formik.values.WarehouseName || '',
          totalAmount: (parseFloat(item.Quantity) || 1) * (parseFloat(item.UnitCost) || 0),
        };

        if (existingIndex !== -1) {
          // Update existing item
          newItems.push({ ...tableData[existingIndex], ...newItem });
        } else {
          // Add new item
          newItems.push(newItem);
        }
      }

      // Validate quantities for all items at once
      try {
        setIsLoadingAddToCart(true);

        let message = await Promise.all(
          newItems.map((item) => {
            return fetchActionsUtil(
              `${backendUrl}/api/production/check-quantity-items/${plantLocal.PLID}`,
              'POST',
              token,
              item
            );
          })
        );
        message = message
          .map(({ message: msg }) => {
            console.log(msg);
            return msg.length ? msg[0]?.message : false;
          })
          .filter(Boolean);
        console.log('message: ', message);
        if (message.length > 0) {
          const errors = message.map((msg, i) => (
            <div className='my-2' key={i}>
              {i + 1}. {msg}
            </div>
          ));
          setErrorMessage(errors);
          // return;
          // continue;
        } else {
          setErrorMessage(null);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoadingAddToCart(false);
      }

      // Update table data
      const updatedTableData = [...tableData];
      newItems.forEach((newItem) => {
        const existingIndex = updatedTableData.findIndex(
          (tableItem) => tableItem.Bar_Code === newItem.Bar_Code
        );

        if (existingIndex !== -1) {
          updatedTableData[existingIndex] = newItem;
        } else {
          updatedTableData.push(newItem);
        }
      });

      setTableData(updatedTableData);
    } else {
      // Handle single item (fallback for individual item selection)
      if (!items?.accountName || !items?.DetailType) {
        return toast.error('Add account to this template');
      }

      const existingIndex = tableData.findIndex((item) => item.Bar_Code === items.Bar_Code);

      const newItem = {
        ...items,
        Quantity: items.Quantity || 1,
        UnitCost: items.UnitCost || 0,
        Date_Log: moment(new Date()),
        UserName: user.username,
        plant: plantLocal?.PLID,
        issueTo: formik.values.issueTo || '',
        Requester: formik.values.Requester || '',
        RequesterName: formik.values.RequesterName || '',
        Warehouse: formik.values.Warehouse || '',
        WarehouseName: formik.values.WarehouseName || '',
        totalAmount: (parseFloat(items.Quantity) || 1) * (parseFloat(items.UnitCost) || 0),
      };

      const newData = await ShowProjectedItemsDialog({ mainData: newItem });

      if (!newData) {
        return;
      }

      // newData = returnData;

      const newPro = newData?.prod_profiles?.map((el) => ({
        ...el,
        quantity: parseFloat(el?.actual) + parseFloat(el?.damage),
      }));

      const newitems = { ...newData, prod_profiles: newPro };

      try {
        setIsLoadingAddToCart(true);
        const { message } = await fetchActionsUtil(
          `${backendUrl}/api/production/check-quantity-items/${plantLocal.PLID}`,
          'POST',
          token,
          newitems
        );

        if (message.length > 0) {
          const errors = message.map((item, i) => (
            <div className='my-2'>
              {i + 1}. {item?.message}
            </div>
          ));
          return setErrorMessage(errors || 'Item Required not enough');
        } else {
          setErrorMessage(null);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoadingAddToCart(false);
      }
      if (existingIndex !== -1) {
        const updatedTableData = [...tableData];
        updatedTableData[existingIndex] = newitems;
        setTableData(updatedTableData);
      } else {
        setTableData((prev) => [...prev, newitems]);
      }
      console.log('closing popover');
      setShowItemsPopover(false);
      setShowPopoverItems(false);
    }
  };

  const onDelete = (barcode) => {
    const item = tableData.filter((d) => d.Bar_Code !== barcode);
    setTableData(item);
  };

  const getStaffs = async (name) => {
    let sendTo = '';
    const sendToUrl = `${backendApis.find((el) => el.name === name)}/api/users`;
    if (sendToUrl) {
      sendTo = sendToUrl.url || '';
      const staffs = await fetchActionsUtil(sendTo, 'GET');
      staffs.staff = staffs.staff.map((el) => ({
        value: `${el.Name}-${el.email}`,
        label: el.Name,
      }));
      setAllStaff(staffs.staff);
    }
  };

  const getWarehouse = async (name) => {
    let sendTo = '';
    const sendToUrl = `${backendApis.find((el) => el.name === name)}/api/warehouse`;
    if (sendToUrl) {
      sendTo = sendToUrl || '';
      const { warehouses } = await fetchActionsUtil(sendTo, 'GET');
      const ware = [
        {
          value: '',
          label: 'Select Warehouse',
        },
        {
          value: 'Sales',
          label: 'Sales',
        },
        ...warehouses?.map((el) => ({
          value: `${el.W_ID}`,
          label: el.W_name,
        })),
      ];
      setAllWarehouse(ware);
    }
  };

  // Update all table items when form values change
  const updateAllTableItems = (field, value) => {
    const updatedTableData = tableData.map((item) => ({
      ...item,
      [field]: value,
    }));
    setTableData(updatedTableData);
  };

  return (
    <Modal
      onHide={props.onHide}
      show={props.show}
      backdropClassName={`global-backdrop`}
      aria-labelledby='contained-modal-title-vcenter'
      centered
      dialogClassName='my-style-modal'
      animation={false}
      enforceFocus={false}
      size='xl'
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div>
            <h1>Product Log</h1>
          </div>

          <p>Add product log by filling in the following forms.</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className='container'>
            <div>
              <div className='form-relative'>
                {/*  */}
                <div className='row'>
                  <div className='col-6 mb-3'>
                    <label className='form-label'>
                      {activeSelected === 'Plan' ? 'Select Plan' : 'Select Item'}
                    </label>
                    <InputGroup>
                      <Form.Control
                        placeholder='Click search to select plan or item'
                        value=''
                        readOnly
                      />

                      <Popover
                        isOpen={showItemsPopover}
                        onClickOutside={() => setShowItemsPopover(false)}
                        content={() => (
                          <GetTemplateModal
                            handleSelectedItem={(items) => {
                              handleSelectedItem(items);
                              setActiveSelected('Plan');
                            }}
                            productPlan
                            plant={props?.plant}
                          />
                        )}
                        position='bottom'
                      >
                        <InputGroup.Text onClick={() => setShowItemsPopover(!showItemsPopover)}>
                          <MagnifyIcon />
                        </InputGroup.Text>
                      </Popover>
                    </InputGroup>
                  </div>

                  <div className='col-6 mb-3'>
                    <label className='form-label'>Individual Items</label>
                    <InputGroup>
                      <Form.Control
                        placeholder='Click search to select individual items'
                        value=''
                        readOnly
                      />

                      <Popover
                        isOpen={showPopoverItems}
                        onClickOutside={() => setShowPopoverItems(false)}
                        content={() => (
                          <GetTemplateModal
                            handleSelectedItem={(items) => {
                              handleSelectedItem(items);
                              setActiveSelected('items');
                            }}
                          />
                        )}
                        position='bottom'
                      >
                        <InputGroup.Text onClick={() => setShowPopoverItems(!showPopoverItems)}>
                          <MagnifyIcon />
                        </InputGroup.Text>
                      </Popover>
                    </InputGroup>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-4 mb-3'>
                    <label className='form-label mb-0'>
                      Issue to{' '}
                      <span onClick={() => props?.refetchMain()}>
                        <CachedIcon style={{ width: '20px' }} />
                      </span>
                    </label>
                    <Select
                      classNamePrefix={'form-select'}
                      isSearchable={true}
                      isLoading={props?.isLoading}
                      value={issuedToData.find((el) => el.value === formik.values.issueTo)}
                      onChange={({ value }) => {
                        formik.setFieldValue('issueTo', value);
                        updateAllTableItems('issueTo', value);
                        getStaffs(value);
                        getWarehouse(value);
                      }}
                      options={issuedToData}
                    />

                    {formik.touched.issueTo && !!formik.errors.issueTo ? (
                      <span className='custom-invalid-feedback'>{formik.errors.issueTo}</span>
                    ) : null}
                  </div>

                  <div className='col-4 mb-3'>
                    <label className='form-label mb-0'>
                      Warehouse{' '}
                      <span onClick={() => props?.refetchMain()}>
                        <CachedIcon style={{ width: '20px' }} />
                      </span>
                    </label>
                    <Select
                      classNamePrefix={'form-select'}
                      isSearchable={true}
                      isLoading={props?.isLoading}
                      value={allWarehouse.find((el) => el.value === formik.values.Warehouse)}
                      onChange={({ value, label }) => {
                        formik.setFieldValue('Warehouse', value);
                        formik.setFieldValue('WarehouseName', label);
                        formik.setFieldValue('Requester', value);
                        updateAllTableItems('Warehouse', value);
                        updateAllTableItems('WarehouseName', label);
                        updateAllTableItems('Requester', value);
                      }}
                      options={allWarehouse}
                    />

                    {formik.touched.Warehouse && !!formik.errors.Warehouse ? (
                      <span className='custom-invalid-feedback'>{formik.errors.Warehouse}</span>
                    ) : null}
                  </div>

                  <div className='col-4 mb-3'>
                    <label className='form-label'>
                      Receiving Officer{' '}
                      <span onClick={() => props?.refetchMain()}>
                        <CachedIcon />
                      </span>
                    </label>
                    <Select
                      classNamePrefix={'form-select'}
                      isSearchable={true}
                      isLoading={props?.isLoading}
                      value={allstaff.find((el) => el.value === formik.values.receivingofficer)}
                      onChange={({ value }) => {
                        formik.setFieldValue('receivingofficer', value);
                        formik.setFieldValue('RequesterName', value);
                        updateAllTableItems('RequesterName', value);
                      }}
                      options={allstaff}
                    />

                    {formik.touched.receivingofficer && !!formik.errors.receivingofficer ? (
                      <span className='custom-invalid-feedback'>
                        {formik.errors.receivingofficer}
                      </span>
                    ) : null}
                  </div>
                </div>

                {/* Table */}
                <div className='mt-5 mb-4'>
                  <Table responsive borderless striped className='product-table'>
                    <thead>
                      <tr>
                        <th />
                        <th>S/N</th>
                        <th>Bar Code</th>
                        <th>Name</th>
                        <th>Quantity</th>
                        <th>UOM</th>
                        <th>Unit Cost</th>
                        <th>Production Date</th>
                        <th>Sub Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.length > 0 &&
                        tableData?.map((el, index) => (
                          <tr
                            key={index}
                            className={`${activeTableIndex === index && 'active-row'}`}
                            onClick={() => activeTableIndex !== index && setActiveTableIndex(index)}
                          >
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant=''
                                  className='bg-white border-0'
                                  bsPrefix='print more'
                                  style={{ height: '3px' }}
                                >
                                  <DotsHorizontalIcon />
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                  popperConfig={{
                                    strategy: 'fixed',
                                  }}
                                  renderOnMount
                                  className='dropdown-with-icons'
                                >
                                  <Dropdown.Item as='button' onClick={() => onDelete(el.Bar_Code)}>
                                    <DeleteIcon className='text-danger' />
                                    Delete
                                  </Dropdown.Item>
                                  <Dropdown.Item as='button' onClick={() => addToTable(el, index)}>
                                    <TagSimpleIcon className='text-light' />
                                    Edit
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                            <td>{index + 1}</td>
                            <td>{el.Bar_Code}</td>
                            <td>{el.Item_Name}</td>
                            <td>
                              <input
                                className='form-control form-control-sm'
                                type='number'
                                value={el.Quantity}
                                onKeyDown={(e) => e.key === 'Enter' && e.target.blur()}
                                name='Quantity'
                                onChange={(e) =>
                                  handleInputChange({
                                    index,
                                    name: e.target.name,
                                    value: e.target.value,
                                  })
                                }
                              />
                            </td>
                            <td>{el?.Product_Model}</td>
                            <td>
                              <input
                                className='form-control form-control-sm'
                                type='number'
                                value={el.UnitCost}
                                onKeyDown={(e) => e.key === 'Enter' && e.target.blur()}
                                name='UnitCost'
                                onChange={(e) =>
                                  handleInputChange({
                                    index,
                                    name: e.target.name,
                                    value: e.target.value,
                                  })
                                }
                              />
                            </td>
                            <td>
                              <DateTime
                                timeFormat={false}
                                closeOnSelect={true}
                                closeOnClickOutside={true}
                                dateFormat='MMM DD, YYYY'
                                inputProps={{
                                  className: `form-control form-control-sm`,
                                  placeholder: 'Select date',
                                  readOnly: true,
                                }}
                                value={el.Date_Log}
                                onChange={(date) => {
                                  handleInputChange({
                                    index,
                                    name: 'Date_Log',
                                    value: date,
                                  });
                                }}
                              />
                            </td>
                            <td className='d-flex align-items-center'>
                              {currency(parseFloat(el?.totalAmount) || 0, {
                                symbol: '',
                              }).format()}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>

                {/*  */}

                {errorMessage && (
                  <div className='d-flex justify-content-center'>
                    <p className='text-danger'>
                      <b>{errorMessage}</b>
                    </p>
                  </div>
                )}

                <div className='add-to-cart-holder d-flex justify-content-end text-primary mt-5'>
                  <div>
                    <Button
                      variant='outline-primary'
                      onClick={formik.handleSubmit}
                      disabled={sendProductLog.isLoading}
                    >
                      {sendProductLog.isLoading ? 'Sending...' : ' Post Production'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <ModalLoader show={sendProductLog.isLoading || isLoading || isLoadingAddToCart} />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
